var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "step-box" },
    [
      _c("i18n", {
        staticClass: "step step-1",
        attrs: {
          path: "demo.demoRegistration.stepMenu.step1.step",
          tag: "div",
        },
        scopedSlots: _vm._u([
          {
            key: "text",
            fn: function () {
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("demo.demoRegistration.stepMenu.step1.text"))
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("i18n", {
        staticClass: "step step-2",
        attrs: {
          path: "demo.demoRegistration.stepMenu.step2.step",
          tag: "div",
        },
        scopedSlots: _vm._u([
          {
            key: "text",
            fn: function () {
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("demo.demoRegistration.stepMenu.step2.text"))
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("i18n", {
        staticClass: "step step-3",
        attrs: {
          path: "demo.demoRegistration.stepMenu.step3.step",
          tag: "div",
        },
        scopedSlots: _vm._u([
          {
            key: "text",
            fn: function () {
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("demo.demoRegistration.stepMenu.step3.text"))
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("i18n", {
        staticClass: "step step-4",
        attrs: {
          path: "demo.demoRegistration.stepMenu.step4.step",
          tag: "div",
        },
        scopedSlots: _vm._u([
          {
            key: "text",
            fn: function () {
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("demo.demoRegistration.stepMenu.step4.text"))
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }